module.exports = __webpack_public_path__ + "img/core-first-3.72898326.png";